import { render } from "./CollectionDetail.vue?vue&type=template&id=0987b816&scoped=true&ts=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=ts"
export * from "./CollectionDetail.vue?vue&type=script&lang=ts"

import "./CollectionDetail.vue?vue&type=style&index=0&id=0987b816&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0987b816"]])

export default __exports__